import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Locator } from './Locator';
import { api } from '../lib/api';

export const LocatorWrapper: React.FC = () => {
  const locatorQuery = useQuery({
    queryKey: ['locator'],
    queryFn: async () => {
      return api.locator();
    },
  });

  if (locatorQuery.isError) {
    return <div>Failed to load store locator data</div>;
  }

  if (locatorQuery.isPending) {
    return <div />;
  }

  return <Locator data={locatorQuery.data} />;
};
